<template>
  <div>
    <Hero is-info-page class="h-full" />
    <Portal to="hero-extra">
      <div class="pt-20 pb-10 h-full px-8 mx-auto max-w-md referral-page">
        <div class="relative h-full">
          <h1 class="text-xl">We'd like to chat</h1>
          <p class="leading-normal">
            Based on the information you've provided, we think you'd benefit from a personalised quote.
          </p>
          <p class="leading-normal">
            Please give us a call us on <a class="text-white underline hover:text-white hover:no-underline" href="tel:+443337720759">0333 772 0759</a> or send an email to <a
              class="text-white underline hover:text-white hover:no-underline"
              :href="`mailto:hello@digitalrisks.co.uk?Subject=Quote ${$store.getters.getReference}`"
              target="_blank" rel="noopener noreferrer"
            >hello@digitalrisks.co.uk</a>.
          </p>
          <p class="leading-normal"> Quote your reference number {{ $store.getters.getReference }}. </p>
          <div class="absolute bottom-0 w-full">
            <DrButton class="btn-cyan btn-block" @click.prevent="closeWidget">Done</DrButton>
          </div>
        </div>
      </div>
    </Portal>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import axiosQuoteApi from '@/services/axiosQuoteApi'

export default {
  mounted () {
    axiosQuoteApi.post(`quote/${this.$store.getters.getQuoteId}/refer`, {
      email: this.$store.getters.getEmail,
      businessName: this.$store.getters.getBusinessName,
      firstName: this.$store.getters.getFirstName,
      lastName: this.$store.getters.getLastName,
    })
  },
  methods: {
    closeWidget () {
      Cookies.remove('dr-store')
      window.parent.postMessage(
        {
          type: 'close-iframe',
          payload: {
            from: 'dr-widget',
          },
        },
        '*'
      )
    },
  },
}
</script>

<style scoped>
@media screen and (orientation: landscape) and (max-height: 660px) {
  .referral-page {
    @apply pt-5 pb-8;
  }
}
</style>
